<template>
  <a-modal
    v-model:visible="fabricVisible"
    :title="false"
    width="100%"
    :closable="false"
    :maskClosable="false"
  >
    <div class="header df mb20" style="justify-content: space-between;">
      <div>
        <b class="fs16 lh30">
          {{ `编辑图片` }}
        </b>
      </div>

      <div>
        <a-button type="text" class="mr10" @click="initFont">
          <FormOutlined />添加标题
        </a-button>
        <a-upload
          v-model:fileList="fileList"
          :show-upload-list="false"
          name="file"
          :multiple="true"
          :customRequest="e => upload(e, false)"
          :accept="'.png,.jpg,.jpeg,.gif'"
          :headers="headers"
          :remove="false"
        >
          <a-button type="text" class="mr10"
            ><FileImageOutlined /><span>导入素材</span></a-button
          >
        </a-upload>
        <a-button type="text" @click="initArea">
          <GatewayOutlined />添加区域
        </a-button>
        <a-button type="text" @click="initButton">
          <AppstoreAddOutlined /> 添加按钮
        </a-button>
        <a-button
          type="text"
          @click="
            () =>
              initFillArea(
                fabricMedia === 1
                  ? 'PC'
                  : fabricMedia === 2
                  ? route.query.terminalId - 0 === 1
                    ? 'H5'
                    : 'APP'
                  : 'iPad'
              )
          "
        >
          <BlockOutlined /> 添加蒙层
        </a-button>
        <a-upload
          v-model:fileList="fileList"
          :show-upload-list="false"
          name="file"
          :multiple="true"
          :customRequest="e => upload(e, true)"
          :accept="'.png,.jpg,.jpeg,.gif'"
          :headers="headers"
          :remove="false"
        >
          <a-button type="text" class="mr10"
            ><CloudSyncOutlined /><span> 更换封面</span></a-button
          >
        </a-upload>
        <a-button type="text" @click="addCountDown">添加倒计时</a-button>
      </div>
      <div>
        <a-button class="mr10" @click="() => clearOrShowBar(true)"
          >还原图层</a-button
        >
        <a-button
          class="mr20"
          type="primary"
          @click="
            () => {
              resetImg()
            }
          "
          >应用</a-button
        >
        <span
          class="cp"
          @click="() => changeFabricVisible({ fabricVisible: false })"
          ><CloseOutlined
        /></span>
      </div>
    </div>
    <div class="fabricContainer">
      <div class="canvasContainer">
        <div
          class="canvas"
          :style="`width: 1920px; height: 400px;`"
          v-if="fabricMedia === 1"
        >
          <canvas width="1920" height="400" ref="fabricDom"></canvas>
        </div>
        <div
          class="canvas"
          :style="`width: 1242px; height: 600px;`"
          v-if="fabricMedia === 2 && route.query.terminalId - 0 === 1"
        >
          <canvas width="1242" height="600" ref="fabricDom"></canvas>
        </div>
        <div
          class="canvas"
          :style="`width: 1125px; height: 420px;`"
          v-if="fabricMedia === 2 && route.query.terminalId - 0 === 2"
        >
          <canvas width="1125" height="420" ref="fabricDom"></canvas>
        </div>
        <div
          class="canvas"
          :style="`width: 1024px; height: 200px;`"
          v-if="fabricMedia === 3"
        >
          <canvas width="1024" height="200" ref="fabricDom"></canvas>
        </div>
      </div>
      <div class="attrsContainer fontEdit">
        <div>
          <div class="oh h30 lh30 mb10" v-if="fontEdit !== 1">
            <b class="fl fs16">{{ titleOptions[fontEdit] }}</b>
            <span class="fr"><DeleteOutlined @click="deleteObject"/></span>
          </div>
          <p class="tac" v-if="fontEdit === 1">
            {{
              `${
                fabricMedia === 1
                  ? 'PC'
                  : fabricMedia === 2
                  ? route.query.terminalId - 0 === 1
                    ? 'H5'
                    : 'APP'
                  : 'iPad'
              }Banner图尺寸`
            }}
          </p>
          <p class="tac"></p>
          <div class="mb10" v-if="fontEdit === 1">
            <div
              class="df"
              style="justify-content: space-between;"
              v-if="fabricMedia === 1"
            >
              <span>宽：1920</span>
              <span>高：400</span>
            </div>
            <div
              class="df"
              style="justify-content: space-between;"
              v-if="fabricMedia === 2"
            >
              <template v-if="route.query.terminalId - 0 === 1">
                <span>宽：1242</span>
                <span>高：600</span>
              </template>
              <template v-if="route.query.terminalId - 0 === 2">
                <span>宽：1125</span>
                <span>高：420</span>
              </template>
            </div>
            <div
              class="df"
              style="justify-content: space-between;"
              v-if="fabricMedia === 3"
            >
              <span>宽：1024</span>
              <span>高：200</span>
            </div>
          </div>
        </div>

        <div v-if="fontEdit === 2">
          <div class="font-li fontF">
            <span>字体：</span>
            <a-select
              ref="select"
              v-model:value="fontStyle.fontFamily"
              style="width: 110px"
              @change="e => changeActiveObject({ fontFamily: e })"
            >
              <a-select-option
                v-for="(item, key) in fontOptions"
                :key="key"
                :value="item.value"
                >{{ item.label }}</a-select-option
              >
            </a-select>
          </div>
          <div class="font-li fontS">
            <span>字号：</span>
            <a-input-number
              style="width: 80px"
              v-model:value="fontStyle.fontSize"
              class="mr10"
              @change="e => changeActiveObject({ fontSize: e })"
            />
            <span>px</span>
          </div>
          <div class="font-li">
            <span>样式：</span>
            <span
              class="mr10 cp"
              @click="() => changeActiveObject({ fontStyle: 'italic' })"
              ><ItalicOutlined
            /></span>
            <span
              class="mr10 cp"
              @click="() => changeActiveObject({ fontStyle: 'normal' })"
              ><RetweetOutlined
            /></span>
            <span
              class="cp"
              @click="() => changeActiveObject({ underline: true })"
              ><UnderlineOutlined
            /></span>
          </div>
          <div class="font-li">
            <span>对齐：</span>
            <span class="mr10"
              ><AlignLeftOutlined @click="() => changeActiveObject({ left: 1 })"
            /></span>
            <span class="mr10"
              ><AlignCenterOutlined
                @click="() => changeActiveObject({ left: 2 })"
            /></span>
            <span class="mr10"
              ><AlignRightOutlined
                @click="() => changeActiveObject({ left: 3 })"
            /></span>
          </div>
          <div class="font-li">
            <span>颜色：</span>
            <span class="colorP"
              ><color-picker v-model:pureColor="fontStyle.fill"
            /></span>
          </div>
        </div>
        <div>
          <div class="font-li df mb10" v-if="fontEdit === 5 || fontEdit === 6">
            <span>背景：</span>
            <div class="df">
              <ColorPicker format="hex6" v-model:pureColor="fontStyle.fill" />
              <a-input-number
                v-model:value="fontStyle.opacity"
                :min="0"
                :max="1"
                :step="0.1"
              />
            </div>
          </div>
        </div>
        <div class="count-down" v-if="fontEdit === 7">
          <p>活动起止时间（GMT+1）</p>
          <a-range-picker
            v-model:value="value2"
            @change="onChangeRange"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
          />
          <p>倒计时字体颜色</p>
          <div class="">
            <ColorPicker
              format="hex6"
              v-model:pureColor="countdownStyle.fill"
              @pure-color-change="value => pureChange('fill', value)"
            ></ColorPicker>
            <a-input-number
              v-model:value="countdownStyle.fillOpacity"
              :min="0"
              :max="1"
              :step="0.1"
              @change="e => changeFontOption(e, 'countFont')"
            />
          </div>
          <p>倒计时背景颜色</p>
          <!-- {{ countdownStyle.backgroundColor }} -->
          <div class="">
            <!-- format="hex6" -->
            <!-- :format="postParams.colMaster.terminalId - 0 === 2 ? 'hex6' : ''" -->
            <ColorPicker
              format="hex6"
              v-model:pureColor="countdownStyle.backgroundColor"
              @pure-color-change="args => pureChange('backgroundColor', args)"
            />
            <a-input-number
              v-model:value="countdownStyle.backgroundOpacity"
              :min="0"
              :max="1"
              :step="0.1"
              @change="e => changeFontOption(e, 'countBg')"
            />
          </div>
          <p>文案字体颜色</p>
          <div class="">
            <ColorPicker
              format="hex6"
              v-model:pureColor="countdownStyle.fontColor"
              @pure-color-change="changeFontColor"
            />
            <a-input-number
              v-model:value="countdownStyle.fontOpacity"
              :min="0"
              :max="1"
              :step="0.1"
              @change="e => changeFontOption(e, 'font')"
            />
          </div>
          <p>字体大小</p>

          <div
            class="font-li fontS"
            v-if="postParams.colMaster.terminalId - 0 === 1"
          >
            <a-select
              v-model:value="countdownStyle.fontSizeType"
              placeholder="请选择"
              @change="changeFontSize"
              style="width: 100%;"
            >
              <a-select-option :value="1">H1(30-24-16)</a-select-option>
              <a-select-option :value="2">H2(24-16-14)</a-select-option>
              <a-select-option :value="3">H3(18-16-12)</a-select-option>
            </a-select>
          </div>
          <div
            class="font-li fontS"
            v-if="postParams.colMaster.terminalId - 0 === 2"
          >
            <div class="font-li fontS">
              <span>字号：</span>
              <a-input-number
                style="width: 80px"
                v-model:value="countdownStyle.fontSize"
                class="mr10"
                @change="e => changeObjectFontsize({ fontSize: e })"
              />
              <span>px</span>
            </div>
          </div>
        </div>
        <div>
          <div class="font-li df mb10" v-if="fontEdit !== 1 && fontEdit !== 5">
            <span class="lh30">图层：</span>
            <div class="df">
              <span class="lh30">当前层级为：</span>
              <div class="mr4">
                <a-input-number
                  v-model:value="fontStyle.zIndex"
                  :min="2"
                  :step="1"
                  :disabled="fontEdit === 7"
                />
              </div>
              <span class="lh30">层</span>
              <!-- <div class="sortIcon cp" @click="() => changeLayer(1, 1)">
                <CaretUpOutlined />
              </div>
              <div
                style="background: #eeeeee; text-align: center; height: 30px; line-height: 30px; font-size: 12px;"
              >
                当前第{{ fontStyle.zIndex }}层
              </div>
              <div class="sortIcon cp" @click="() => changeLayer(2, -1)">
                <CaretDownOutlined />
              </div> -->
            </div>
          </div>
        </div>
        <div class="font-li fontF" v-if="fontEdit === 4">
          <span>事件：</span>
          <a-select
            ref="select"
            v-model:value="fontStyle.eventName"
            style="width: 150px"
            @change="e => changeActiveObject({ eventName: e })"
          >
            <a-select-option :value="1">地址跳转</a-select-option>
            <a-select-option :value="2">拷贝</a-select-option>
            <a-select-option :value="3">登录/注册弹窗</a-select-option>
            <a-select-option :value="4">订阅弹窗</a-select-option>
            <a-select-option v-if="$route.query.terminalId == 1" :value="6"
              >登录/注册弹窗Plus</a-select-option
            >

            <a-select-option v-if="$route.query.terminalId == 2" :value="7">
              APP PUSH
            </a-select-option>
            <a-select-option v-if="$route.query.terminalId == 2" :value="8">
              订阅日历
            </a-select-option>
          </a-select>
        </div>
        <div class="font-li fontF lh32" v-if="fontEdit === 4">
          <span>id：</span>
          {{ fontStyle.id }}
        </div>
        <div
          class="font-li fontF"
          v-if="fontEdit === 4 && fontStyle.eventName === 1"
        >
          <span>链接：</span>
          <a-input
            class="w180"
            v-model:value="fontStyle.href"
            @change="e => changeActiveObject({ href: e.target.value })"
          />
        </div>
        <div
          class="font-li fontF"
          v-if="fontEdit === 4 && fontStyle.eventName === 2"
        >
          <span>拷贝文案：</span>
          <a-textarea
            class="w200"
            v-model:value="fontStyle.copyText"
            @change="e => changeActiveObject({ copyText: e.target.value })"
          />
        </div>

        <div v-if="fontEdit === 2">
          <a-button type="defalut" style="width: 100%;" @click="reSet"
            >重置</a-button
          >
        </div>
      </div>
    </div>
    <template #footer> </template>
  </a-modal>
</template>
<script>
import { ColorPicker } from '@cupshe/vue3-colorpicker'
import '@cupshe/vue3-colorpicker/style.css'
import { fabric } from 'fabric'
import {
  toRefs,
  reactive,
  onMounted,
  watch,
  inject,
  watchEffect,
  nextTick
} from 'vue'
import { formRequest } from 'cupshe-axios'
import {
  // CaretDownOutlined,
  // CaretUpOutlined,
  FormOutlined,
  FileImageOutlined,
  GatewayOutlined,
  ItalicOutlined,
  AlignLeftOutlined,
  AlignCenterOutlined,
  AlignRightOutlined,
  CloseOutlined,
  RetweetOutlined,
  UnderlineOutlined,
  BlockOutlined,
  AppstoreAddOutlined,
  CloudSyncOutlined,
  DeleteOutlined
} from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import duration from 'dayjs/plugin/duration'
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(duration)

// 添加倒计时文本
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    let r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
const textBox = new fabric.Textbox('Ends in', {
  fontSize: 24,
  fill: '#1f1f1f',
  left: 0,
  top: 0,
  fontFamily: 'Avenir Next LT Pro',
  fontWeight: 'normal',
  width: 120,
  // height: 40,
  textAlign: 'center'
})

const daysText = new fabric.Textbox('99', {
  fontSize: 24,
  left: 120,
  fill: '#1f1f1f',
  backgroundColor: '#ffffff',
  width: 40,
  // height: 40,
  textAlign: 'center'
})
const DBox = new fabric.Textbox('D:', {
  fontSize: 24,
  fill: '#1f1f1f',
  left: 160,
  width: 40,
  // height: 40,
  textAlign: 'center'
})

const hoursText = new fabric.Textbox('99', {
  fontSize: 24,
  left: 200,
  fill: '#1f1f1f',
  backgroundColor: '#ffffff',
  width: 40,
  // height: 40,
  textAlign: 'center'
})
const hText = new fabric.Textbox('H:', {
  left: 240,
  fontSize: 24,
  fill: '#1f1f1f',
  width: 40,
  // height: 40,
  textAlign: 'center'
})

const minutesText = new fabric.Textbox('99', {
  left: 280,
  fontSize: 24,
  fill: '#1f1f1f',
  backgroundColor: '#ffffff',
  width: 40,
  // height: 40,
  textAlign: 'center'
})
const mText = new fabric.Textbox('M:', {
  left: 320,
  fontSize: 24,
  fill: '#1f1f1f',
  width: 40,
  // height: 40,
  textAlign: 'center'
})

const secondsText = new fabric.Textbox('99', {
  left: 360,
  fontSize: 24,
  fill: '#1f1f1f',
  backgroundColor: '#ffffff',
  width: 40,
  // height: 40,
  textAlign: 'center'
})
const sText = new fabric.Textbox('S', {
  left: 400,
  fontSize: 24,
  fill: '#1f1f1f',
  width: 40,
  // height: 40,
  textAlign: 'center'
})

function rgbaToHex(rgbaColor) {
  // 提取 RGBA 颜色通道的值
  const rgbaRegex = /rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/
  const matches = rgbaColor.match(rgbaRegex)
  if (!matches) {
    return null // 非法的颜色值
  }

  const red = parseInt(matches[1], 10)
  const green = parseInt(matches[2], 10)
  const blue = parseInt(matches[3], 10)
  const alpha = parseFloat(matches[4] || 1)

  // 将透明度值转换为十六进制，并保留两位小数
  const alphaHex = Math.round(alpha * 255)
    .toString(16)
    .padStart(2, '0')

  // 将 RGBA 颜色转换为 HEX 颜色，并添加透明度信息
  const hexColor = `#${red.toString(16).padStart(2, '0')}${green
    .toString(16)
    .padStart(2, '0')}${blue.toString(16).padStart(2, '0')}${alphaHex}`

  return hexColor
}

const rgbaColor = 'rgba(5, 160, 69, .5)'
const hexColor = rgbaToHex(rgbaColor)
console.log(hexColor) // 输出：#05a045ff

export default {
  components: {
    UnderlineOutlined,
    // CaretDownOutlined,
    // CaretUpOutlined,
    FormOutlined,
    FileImageOutlined,
    GatewayOutlined,
    ItalicOutlined,
    AlignLeftOutlined,
    AlignCenterOutlined,
    AlignRightOutlined,
    ColorPicker,
    CloseOutlined,
    RetweetOutlined,
    BlockOutlined,
    AppstoreAddOutlined,
    CloudSyncOutlined,
    DeleteOutlined
  },
  setup() {
    let canvas = null
    let {
      uploadHandleChange,
      setInfo,
      fabricMedia,
      postParams,
      compare
    } = inject('initState')
    const state = reactive({
      hasChangedImg: false,
      titleOptions: {
        1: '',
        2: '标题',
        3: '素材',
        4: '区域',
        5: '蒙层',
        6: '按钮',
        7: '倒计时',
        8: ''
      },
      recordTarget: null,
      fontOptions: [
        { value: 'AvenirNext-Bold', label: 'Bold' },
        { value: 'AvenirNext-Demi', label: 'Demi' },
        { value: 'AvenirNext-Medium', label: 'Medium' },
        { value: 'AvenirNext-Regular', label: 'Regular' }
      ],
      upload: (info = null, change = false) => {
        state.fileList = [info.file]
        state.info = info
        state.uploadHandleChange(change)
      },
      uploadHandleChange: async (change = false) => {
        const { info } = state
        if (info && info.file) {
          const api = `${process.env.VUE_APP_CMS}/cms/material/upload`
          const { success, retInfo, data: data_ } = await formRequest(api, {
            file: info.file
          })
          let data = data_.url
          if (success) {
            state['fileList'] = [data]
            state.initPic(data, change ? false : true, change)
            state['fileList'] = []
            message.success(`上传成功！`)
            state.hasChangedImg = true
          } else {
            state.fileList = []
            message.error(retInfo)
          }
        } else {
          message.info('文件未上传！')
        }
      },
      clearChoose: () => {
        canvas.discardActiveObject()
        canvas.requestRenderAll()
      },
      uploadHeaders: {
        Authorization:
          localStorage.getItem('token') || '0e044f64c5364f93a5cb83731a09b8b9'
      },
      fileList: [],
      fontEdit: 1,
      initFontStyle: {
        zIndex: -1,
        eventName: 1,
        href: null,
        fontSize: 30,
        fontFamily: 'AvenirNext-Bold',
        textAlign: 'left',
        fill: 'black',
        copyText: '',
        gradientColor:
          'linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 100%)',
        fontStyle: 'normal' // oblique 斜体
      },
      fontStyle: {
        zIndex: -1,
        eventName: 1,
        href: null,
        fontSize: 30,
        fontFamily: 'AvenirNext-Bold',
        textAlign: 'left',
        copyText: '',
        fill: 'black',
        gradientColor:
          'linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 100%)',
        fontStyle: 'normal' // oblique 斜体
      },
      fabricDom: null,
      canvas: null,
      mediaType: 1,
      width: 1920,
      height: 400,
      removePic: () => {},
      initFont: () => {
        let initFontStyle = { ...state.initFontStyle }
        delete initFontStyle.gradientColor
        delete initFontStyle.fill
        let font = new fabric.IText('enter text', {
          keyName: new Date().getTime(),
          top: 100,
          left: 100,
          lockScalingX: true,
          lockScalingY: true,
          picType: 'font',
          fill: 'black',
          ...initFontStyle,
          opacity: 1,
          zIndex: canvas.getObjects().length + 2
        })
        font.on('selected', e => {
          state.recordTarget = e
          const { target } = e
          const {
            fontSize,
            fontFamily,
            textAlign,
            fill,
            fontStyle,
            zIndex
          } = target
          state.fontStyle = {
            fontSize,
            fontFamily,
            textAlign,
            fill,
            fontStyle,
            zIndex
          }
          state.fontEdit = 2
        })
        canvas.add(font)
      },
      initPic: (src = null, selectable = true, initPicStatus = false) => {
        if (!src) return
        canvas.discardActiveObject()
        canvas.renderAll()
        if (initPicStatus) {
          let obj = canvas
            .getObjects()
            .filter(v => v.zIndex <= 0 && v.picType === 'img')[0]
          canvas.remove(obj)
        }
        let img = document.createElement('img')
        img.setAttribute('crossOrigin', 'anonymous')
        img.src = src
        img.onload = () => {
          if (initPicStatus && canvas.getActiveObject()) {
            canvas.getActiveObject()[0].setSrc(img.src, () => {})
            canvas.getActiveObject()[0].set('zIndex', -1)
            canvas.getActiveObject()[0].moveTo(-1)
            canvas.requestRenderAll()
            return
          }
          let imgObj = new fabric.Image(img, {
            keyName: new Date().getTime(),
            left: 0, // 图片相对画布的左侧距离
            top: 0, // 图片相对画布的顶部距离
            strokeWidth: 0,
            picType: 'img',
            opacity: 1,
            zIndex: initPicStatus
              ? -1
              : selectable
              ? canvas.getObjects().length + 2
              : -1,
            selectable: initPicStatus ? false : selectable
          })
          imgObj.on('selected', e => {
            state.recordTarget = e
            state.fontEdit = 3
          })
          canvas.add(imgObj)
          canvas.getObjects().filter(v => {
            if (v.zIndex <= 0 && v.picType === 'img') {
              v.moveTo(0)
            }
            return v
          })
          canvas.requestRenderAll()
        }
      },
      initArea: () => {
        let rect = new fabric.Rect({
          keyName: new Date().getTime(),
          top: 50, //距离画布上边的距离
          left: 100, //距离画布左侧的距离，单位是像素
          width: 100, //矩形的宽度
          height: 70, //矩形的高度
          fill: 'red', //填充的颜色
          // stroke: '#000000', // 边框原色
          opacity: 0.3,
          borderDashArray: [5, 5],
          strokeWidth: 1,
          picType: 'area',
          rectType: 'area',
          href: '',
          eventType: 1,
          zIndex: canvas.getObjects().length + 2,
          id: generateUUID()
        })
        rect.on('selected', e => {
          state.recordTarget = e
          state.fontEdit = 4
        })

        rect.on('drag', () => {
          state.fontEdit = 4
        })
        canvas.add(rect)
      },
      initButton: () => {
        if (!canvas.getObjects()) return
        let width = 200,
          height = 40
        let rect = new fabric.Rect({
          keyName: new Date().getTime(),
          top: 50, //距离画布上边的距离
          left: 50, //距离画布左侧的距离，单位是像素
          width, //矩形的宽度
          height, //矩形的高度
          fill: 'black', //填充的颜色
          // stroke: '#000000', // 边框原色
          opacity: 1,
          borderDashArray: [5, 5],
          strokeWidth: 1,
          picType: 'area-button',
          rectType: 'area-button',
          href: '',
          eventType: 1,
          zIndex: canvas.getObjects().length + 2
        })
        rect.on('selected', e => {
          state.recordTarget = e
          state.fontEdit = 6
        })

        rect.on('drag', () => {
          state.fontEdit = 6
        })
        canvas.add(rect)
        canvas.requestRenderAll()
      },
      initFillArea: media => {
        let width, height
        switch (media) {
          case 'PC':
            width = 1920
            height = 400
            break
          case 'H5':
            width = 1242
            height = 600
            break
          case 'APP':
            width = 1125
            height = 420
            break
          case 'iPad':
            width = 1024
            height = 200
            break
        }
        console.log('height', width, height)
        let rect = new fabric.Rect({
          keyName: new Date().getTime(),
          top: 0, //距离画布上边的距离
          left: 0, //距离画布左侧的距离，单位是像素
          width, //矩形的宽度
          height, //矩形的高度
          fill: 'black', //填充的颜色
          // stroke: '#000000', // 边框原色
          opacity: 0.3,
          strokeWidth: 1,
          picType: 'area-cover',
          rectType: 'area-cover',
          href: '',
          eventType: 1,
          zIndex: 1
        })
        rect.on('selected', e => {
          state.recordTarget = e
          state.fontEdit = 5
        })

        rect.on('drag', () => {
          state.fontEdit = 5
        })
        rect.set('zIndex', 1)
        canvas.add(rect)
        canvas.getObjects().filter(v => {
          if (v.picType === 'area-cover') {
            v.moveTo(1)
          }
          return v
        })
        canvas.requestRenderAll()
      },
      // 删除节点
      deleteObject: () => {
        let target = canvas.getActiveObject()
        if (!target) {
          return
        } else {
          console.log('target', target)
          canvas.remove(target)
          canvas.requestRenderAll()
          let bannerExt = canvas.getObjects()
          bannerExt = bannerExt.sort(compare('zIndex', true))
          console.log('cessssss', bannerExt)
          for (let i = 0; i < bannerExt.length; i++) {
            bannerExt[i].set('zIndex', i)
          }
          state.value2 = []
          state.countdownStyle = {
            fontSize: 24,
            // fontSizeType: 2,
            fill: '#1f1f1f',
            backgroundColor: '#ffffff',
            fontOpacity: null,
            fillOpacity: null,
            fontColor: null
          }
          if (postParams.colMaster.terminalId - 0 === 1) {
            state.countdownStyle.fontSizeType = 2
          }

          state.removeTextBox()
          canvas.requestRenderAll()
          message.warning('节点删除后，层级会自动重排！')
        }
      },
      removeTextBox() {
        // 背景
        textBox.set('fill', '#1f1f1f')
        DBox.set('fill', '#1f1f1f')
        hText.set('fill', '#1f1f1f')
        sText.set('fill', '#1f1f1f')
        mText.set('fill', '#1f1f1f')
        //时间
        daysText.set('fill', '#1f1f1f')
        hoursText.set('fill', '#1f1f1f')
        minutesText.set('fill', '#1f1f1f')
        secondsText.set('fill', '#1f1f1f')

        daysText.set('backgroundColor', '#ffffff')
        hoursText.set('backgroundColor', '#ffffff')
        minutesText.set('backgroundColor', '#ffffff')
        secondsText.set('backgroundColor', '#ffffff')
        const groupMap = [
          textBox,
          daysText,
          DBox,
          hoursText,
          hText,
          minutesText,
          mText,
          secondsText,
          sText
        ]
        groupMap.map(object => {
          console.log('r', object.width)
          object.set('fontSize', 24)
        })
      },
      reSort: () => {
        let bannerExt = canvas.getObjects()
        bannerExt = bannerExt.sort(compare('zIndex', true))
        for (let i = 0; i < bannerExt.length; i++) {
          bannerExt[i].set('zIndex', i)
        }
        canvas.renderAll()
      },
      choose: null,
      repairBug: bannerExt => {
        if (typeof bannerExt === 'string') {
          let newBannerExt = JSON.parse(bannerExt)
          if (newBannerExt.args) {
            if (typeof newBannerExt.args === 'string') {
              return state.repairBug(newBannerExt.args)
            } else {
              return newBannerExt.args
            }
          } else {
            return newBannerExt
          }
        } else {
          return bannerExt
        }
      },
      init: async () => {
        // console.log('textBox', textBox.width)
        canvas = new fabric.Canvas(state.fabricDom)
        fabric.Object.prototype.controls.deleteControl = new fabric.Control({
          x: 0.5,
          y: -0.5,
          offsetY: -20,
          offsetX: 0,
          cursorStyle: 'pointer',
          cornerSize: 24
        })
        const { banners } = postParams.colBanner
        state.removeTextBox()
        console.log('banners', banners)
        banners.forEach(el => {
          // if ([1].includes(el.imgType)) {
          el.bannerExt.forEach(ext => {
            if (ext.type === 'group') {
              const timeRanger = ext.objects[ext.objects.length - 1].text.split(
                '/'
              )
              if (timeRanger.filter(e => e).length > 0) {
                const startTime = dayjs(timeRanger[0], 'YYYY-MM-DD HH:mm:ss')
                const endime = dayjs(timeRanger[1], 'YYYY-MM-DD HH:mm:ss')
                state.value2 = [startTime, endime]
              }
              const fontMap = {
                30: 1,
                24: 2,
                18: 3
              }
              if (postParams.colMaster.terminalId - 0 === 2) {
                state.countdownStyle.fontSizeType =
                  fontMap[ext.objects[0].fontSize] || 2
              }
              state.countdownStyle.fontColor = ext.objects[0].fill
              state.countdownStyle.fontOpacity = ext.objects[0].opacity
              state.countdownStyle.fillOpacity = ext.objects[1].opacity
              state.countdownStyle.fill = ext.objects[1].fill
              state.countdownStyle.backgroundColor =
                ext.objects[1].bgRgba || ext.objects[1].backgroundColor
            }
          })
          // }
        })
        // const a = new fabric.Color('#000000').toHex()
        // console.log('bgRgba', a)
        let filter = banners.filter(item => item.imgType - 0 === fabricMedia)[0]
        filter.bannerExt = state.repairBug(filter.bannerExt)
        if (filter.bannerExt.length === 0) {
          state.initPic(filter.imgUrl, false, true)
        } else {
          let bannerExt = []
          for (let i = 0; i < filter.bannerExt.length; i++) {
            switch (filter.bannerExt[i].type) {
              case 'image':
                {
                  let e = await state.awaitImg(filter.bannerExt[i])
                  bannerExt.push(e)
                }
                break
              case 'i-text':
                new fabric.IText.fromObject(filter.bannerExt[i], e => {
                  bannerExt.push(e)
                })
                break
              case 'text':
                new fabric.Text.fromObject(filter.bannerExt[i], e => {
                  bannerExt.push(e)
                })
                break
              case 'group':
                new fabric.Group.fromObject(filter.bannerExt[i], e => {
                  e.opacity = 1
                  if (postParams.colMaster.terminalId - 0 === 1) {
                    e.lockScalingX = true
                    e.lockScalingY = true
                    e.fontSizeType =
                      e.fontsize === 30 ? 1 : e.fontsize === 24 ? 2 : 3
                  } else {
                    delete e.fontSizeType
                  }

                  bannerExt.push(e)
                })
                break
              case 'rect':
                new fabric.Rect.fromObject(filter.bannerExt[i], e => {
                  bannerExt.push(e)
                })
                break
            }
          }
          bannerExt = bannerExt.sort(compare('zIndex', true))
          console.log('bannerExt', bannerExt)
          for (let i = 0; i < bannerExt.length; i++) {
            bannerExt[i].set('keyName', new Date().getTime())
            canvas.add(bannerExt[i])
          }
          canvas.requestRenderAll()
        }
        state.watchChange()
      },
      awaitImg: (target = null) => {
        return new Promise(resolve => {
          new fabric.Image.fromObject(target, e => {
            let e_ = e
            e_.set('selectable', target.zIndex > 0)
            resolve(e_)
          })
        })
      },
      clearOrShowBar: (leave = false) => {
        if (!canvas.getActiveObject() || leave) {
          state.fontEdit = 1
          state.fontStyle = state.initFontStyle
          canvas.discardActiveObject()
          canvas.requestRenderAll()
          return
        } else {
          let obj = canvas.getActiveObject()
          state.fontStyle = { ...state.fontStyle, ...obj }
          switch (obj.type) {
            case 'image':
              state.fontEdit = 3
              break
            case 'i-text':
              state.fontEdit = 2
              break
            case 'group':
              state.fontEdit = 7
              break
            case 'rect':
              {
                let target = canvas.getActiveObject()
                if (target.rectType === 'area-cover') {
                  state.fontEdit = 5
                } else if (target.rectType === 'area-button') {
                  state.fontEdit = 6
                } else {
                  state.fontEdit = 4
                }
              }

              break
          }
          canvas.requestRenderAll()
        }
      },
      watchChange: () => {
        canvas.on('mouse:move', () => {
          state.clearOrShowBar()
        })
        canvas.on('mouse:down', options => {
          console.log('down')
          let event = options.e
          let ext = canvas.findTarget(event)
          if (ext) {
            // 在这里处理点击了元素的情况
            if (ext.type === 'group') {
              const timeRanger = ext._objects[
                ext._objects.length - 1
              ].text.split('/')
              if (timeRanger.filter(e => e).length > 0) {
                const startTime = dayjs(timeRanger[0], 'YYYY-MM-DD HH:mm:ss')

                const endime = dayjs(timeRanger[1], 'YYYY-MM-DD HH:mm:ss')
                // .format(
                //   'YYYY-MM-DD HH:mm:ss'
                // )
                console.log(11, startTime, endime)

                state.value2 = [startTime, endime]
              }
              const fontMap = {
                30: 1,
                24: 2,
                18: 3
              }

              state.countdownStyle.fontSizeType =
                fontMap[ext._objects[0].fontSize] || 2
              state.countdownStyle.fontSize = ext._objects[0].fontSize
              state.countdownStyle.fontColor = ext._objects[0].fill
              // state.countdownStyle.fontColor = ext._objects[1].fill
              state.countdownStyle.fontSize = ext._objects[1].fontSize
              state.countdownStyle.fontOpacity = ext._objects[0].opacity
              state.countdownStyle.fillOpacity = ext._objects[1].opacity
              state.countdownStyle.fill = ext._objects[1].fill
              state.countdownStyle.backgroundColor =
                ext._objects[1].bgRgba || ext._objects[1].backgroundColor

              canvas.requestRenderAll()
              return
            }
            // if (ext.type === 'i-text') {
            // }
          } else {
            // 在这里处理点击了画布但没有点击元素的情况
            state.clearOrShowBar()
            return false
          }
          state.fontStyle = state.initFontStyle

          state.clearOrShowBar()
        })
        canvas.on('mouse:up', () => {
          state.clearOrShowBar()
        })
      },
      changeActiveObject: (params = {}) => {
        if (!canvas.getActiveObject()) return
        if (params.fontFamily) {
          canvas.getActiveObject().style = {
            ...canvas.getActiveObject().style,
            fontFamily: params.fontFamily
          }
        }

        if (params.fill) {
          canvas.getActiveObject().set('fill', params.fill)
        }

        if (params.fontSize) {
          canvas.getActiveObject().style = {
            ...canvas.getActiveObject().style,
            fontSize: params.fontSize
          }
        }

        if (params.zIndex) {
          canvas.getActiveObject().set('zIndex', params.zIndex)
        }

        if (params.fontStyle) {
          canvas.getActiveObject().style = {
            ...canvas.getActiveObject().style,
            fontStyle: params.fontStyle
          }
        }
        if (params.underline) {
          canvas.getActiveObject().style = {
            ...canvas.getActiveObject().style,
            underline: true
          }
        }

        if (params.eventName) {
          state.fontStyle.copyText = ''
          state.fontStyle.href = ''
          canvas.getActiveObject().eventName = params.eventName
          canvas.getActiveObject().eventType = params.eventType
        }
        if (!canvas.getActiveObject()) {
          state.fontEdit = 1
          // message.warning('请先选中要操作的内容！')
          return
        }

        if (params.href || params.copyText) {
          if (canvas.getActiveObject().type !== 'rect') {
            return
          }
        }
        for (let key in params) {
          if (key === 'left') {
            switch (params[key]) {
              case 1:
                canvas.getActiveObject().set('left', 0)
                break
              case 2:
                {
                  let left =
                    (fabricMedia === 1
                      ? 1920
                      : fabricMedia === 2
                      ? 1242
                      : 1024) /
                      2 -
                    canvas.getActiveObject().get('width') / 2
                  canvas.getActiveObject().set('left', left)
                }
                break
              case 3:
                {
                  let left =
                    (fabricMedia === 1
                      ? 1920
                      : fabricMedia === 2
                      ? 1242
                      : 1024) - canvas.getActiveObject().get('width')
                  canvas.getActiveObject().set('left', left)
                }
                break
            }
          } else {
            canvas.getActiveObject().set(key, params[key])
          }
        }
        canvas.requestRenderAll()
      },
      changeLayer: (way = null, move) => {
        if (!canvas.getActiveObject()) {
          state.fontEdit = 1
          message.warning('请先选中要操作的内容！')
          return
        }
        if (way === 1) {
          if (canvas.getObjects().length - 1 <= state.fontStyle.zIndex) {
            message.warning('已经在最顶层')
            return
          }
          canvas.bringForward(canvas.getActiveObject())
          for (let i = 0; i < canvas.getObjects().length; i++) {
            if (
              canvas.getObjects()[i].zIndex ===
              state.fontStyle.zIndex + move
            ) {
              canvas
                .getObjects()
                [i].set('zIndex', canvas.getObjects()[i].zIndex - 1)
            }
          }
          state.fontStyle.zIndex = state.fontStyle.zIndex + move
          state.changeActiveObject({ zIndex: state.fontStyle.zIndex })
        } else {
          if (state.fontStyle.zIndex <= 2) {
            message.warning('已经在最底层')
            return
          }
          for (let i = 0; i < canvas.getObjects().length; i++) {
            if (
              canvas.getObjects()[i].zIndex ===
              state.fontStyle.zIndex + move
            ) {
              canvas
                .getObjects()
                [i].set('zIndex', canvas.getObjects()[i].zIndex + 1)
            }
          }
          canvas.sendBackwards(canvas.getActiveObject())
          state.fontStyle.zIndex = state.fontStyle.zIndex + move
          state.changeActiveObject({ zIndex: state.fontStyle.zIndex })
        }
      },
      // 重置
      reSet: () => {
        state.fontEdit = 1
        state.fontStyle = { ...state.fontStyle, ...state.initFontStyle }
        for (let key in state.initFontStyle) {
          canvas.getActiveObject().set(key, state.initFontStyle[key])
        }
        canvas.requestRenderAll()
      },
      transform: b64Image => {
        const img = atob(b64Image.split(',')[1])
        const image = []
        let i = 0
        while (i < img.length) {
          image.push(img.charCodeAt(i))
          i++
        }
        return new Uint8Array(image)
      },
      dataURLtoFile: (dataurl, filename) => {
        let arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], filename, { type: mime })
      },
      getIndex: () => {
        // let bannerExt = canvas.getObjects()
        // let zIndex = 1
        // for (let i = 0; i < bannerExt.length; i++) {
        //   if (bannerExt[i].zIndex > zIndex) {
        //     zIndex = bannerExt[i].zIndex + 1
        //   }
        // }
        // return zIndex
      },
      resetImg: () => {
        let bannerExt = canvas.getObjects()
        for (let i = 0; i < bannerExt.length; i++) {
          if (
            bannerExt[i].type === 'rect' &&
            (bannerExt[i].rectType === 'area' ||
              bannerExt[i].rectType === 'rect' ||
              bannerExt[i].rectType === undefined)
          ) {
            bannerExt[i].set({ fill: 'transparent' })
          }
          if (bannerExt[i].type === 'group') {
            bannerExt[i].set({ opacity: 0 })
          }
        }
        let b64Image = canvas.toDataURL('image/png', 1)
        let u8Image = state.transform(b64Image)
        let formData = new FormData()
        formData.append('image', new Blob([u8Image], { type: 'image/png' }))
        let file = state.dataURLtoFile(b64Image, new Date().getTime() + '.png')
        setInfo({ file })
        for (let i = 0; i < bannerExt.length; i++) {
          if (
            bannerExt[i].type === 'rect' &&
            (bannerExt[i].rectType === 'area' ||
              bannerExt[i].rectType === 'rect' ||
              bannerExt[i].rectType === undefined)
          ) {
            bannerExt[i].set({ fill: 'red' })
          }
          if (bannerExt[i].type === 'group') {
            if (postParams.colMaster.terminalId - 0 === 1) {
              const fontMap = {
                30: 1,
                24: 2,
                18: 3
              }
              const fontSize = bannerExt[i]._objects[0].fontSize
              console.log('fontSize', fontSize)
              bannerExt[i].set({ fontSizeType: fontMap[fontSize] || 2 })
              bannerExt[i]._objects.map(e => {
                e.fontSizeType = fontMap[fontSize] || 2
                e.backgroundColor = '#00000000'
                return e
              })
            } else {
              bannerExt[i]._objects.map(e => {
                // if (e.backgroundColor) {
                //   e.backgroundColor = rgbaToHex(e.backgroundColor)
                // }
                e.backgroundColor = '#00000000'
                delete e.fontSizeType
                return e
              })
            }
            console.log('bannerExt[i]', bannerExt[i]._objects)
            // bannerExt[i]._objects.map((e, index) => {
            //   if ([1, 3, 5, 7].includes(index)) {
            //     const hexStr = new fabric.Color(e.backgroundColor).toHex()
            //     console.log('hexStr', hexStr)
            //     e.bgRgba = e.backgroundColor
            //     e.backgroundColor = `#${hexStr}`
            //   }
            //   return e
            // })
          }
        }
        bannerExt = bannerExt.sort(compare('zIndex', true))
        const arr = [
          'href',
          'zIndex',
          'eventName',
          'eventType',
          'copyText',
          'fontEdit',
          'picType',
          'rectType',
          'fill',
          'bgRgba',
          'id'
        ]
        if (postParams.colMaster.terminalId - 0 === 1) {
          arr.push('fontSizeType')
        }
        if (postParams.colMaster.terminalId - 0 === 2) {
          // to do
        }
        bannerExt = canvas.toJSON(arr).objects
        bannerExt = bannerExt.sort(compare('zIndex', true))
        console.log('bannerExt', bannerExt)
        uploadHandleChange(fabricMedia, bannerExt, state.hasChangedImg)
      },
      value2: [],

      addCountDown() {
        state.value2 = []

        const timeText = new fabric.Text('', {
          left: 0,
          top: 0,
          width: 0,
          opacity: 0
        })
        // 添加倒计时文本
        const countdownText = new fabric.Group(
          [
            textBox,
            daysText,
            DBox,
            hoursText,
            hText,
            minutesText,
            mText,
            secondsText,
            sText,
            timeText
          ],
          {
            keyName: new Date().getTime(),
            left: 100,
            top: 100,
            fontSize: 40,
            lockScalingX: true,
            lockScalingY: true,
            opacity: 1,
            zIndex: canvas.getObjects().length + 1
          }
        )
        if (postParams.colMaster.terminalId - 0 === 2) {
          countdownText.set('lockScalingX', false)
          countdownText.set('lockScalingY', false)
        }
        countdownText.on('selected', e => {
          console.log('countdownText', e)
          console.log('countdownText', countdownText)

          state.fontEdit = 7
        })
        canvas.remove(countdownText)
        canvas.add(countdownText)
        canvas.renderAll()
      },
      group: [],

      changeFontOption(option = 1, type) {
        console.log('type', option, type)
        if (!canvas.getActiveObject()) return
        const keyMap = [1, 3, 5, 7]
        const fontopac = [0, 2, 4, 6, 8]
        if (type === 'countFont') {
          keyMap.forEach(key =>
            canvas.getActiveObject()._objects[key].set('opacity', option)
          )
        }
        if (type === 'font') {
          // for (const object of canvas.getActiveObject()._objects) {
          //   console.log('object', object)
          //   object.set('opacity', option)
          // }
          // 设置文案透明度
          fontopac.forEach(key =>
            canvas.getActiveObject()._objects[key].set('opacity', option)
          )
        }
        if (type === 'countBg') {
          keyMap.forEach(key => {
            // const getRgb = canvas.getActiveObject()._objects[1].backgroundColor
            canvas.getActiveObject()._objects[key].set(
              'backgroundColor',
              '#00000000'
              // state.colorRgba(getRgb, option)
            )
          })
        }
        // 倒计时存储
        canvas.getActiveObject()._objects[9].set('opacity', 0)
        canvas.renderAll()
      },
      colorRgba(color, option) {
        return new fabric.Color(color).setAlpha(option).toRgba()
      },
      changeFontColor(value, type = 'fill') {
        if (!canvas.getActiveObject()) return

        const keyMap = [0, 2, 4, 6, 8]
        keyMap.forEach(key => {
          canvas.getActiveObject()._objects[key].set(type, value)
        })

        canvas.renderAll()
      },
      countdownStyle: {
        fontSize: 24,
        fontSizeType: 2,
        fill: '#1f1f1f',
        backgroundColor: '#ffffff'
      },
      pureChange(type, value) {
        console.log('e', type, value)
        if (!canvas.getActiveObject()) return
        const keyMap = [1, 3, 5, 7]
        keyMap.forEach(key => {
          canvas.getActiveObject()._objects[key].set(type, value)
        })
        if (type === 'backgroundColor') {
          state.changeFontOption(
            state.countdownStyle.backgroundOpacity,
            'countBg'
          )
        }
        canvas.requestRenderAll()
      },
      changeFontSize(value) {
        if (!canvas.getActiveObject()) return
        const fontMap = {
          1: 30,
          2: 24,
          3: 18
        }
        const fontsize = fontMap[value]
        const height = canvas.getActiveObject()._objects[1].height

        for (const object of canvas.getActiveObject()._objects) {
          object.set('height', height)
          object.set('fontSize', fontsize)
          object.set('fontSizeType', value)
        }
        canvas.renderAll()
      },

      changeObjectFontsize({ fontSize }) {
        // postParams.colMaster.terminalId - 0 === 2
        if (!canvas.getActiveObject()) return
        const height = canvas.getActiveObject()._objects[1].height
        canvas.renderAll()
        for (const object of canvas.getActiveObject()._objects) {
          object.set('height', height)
          object.set('fontSize', fontSize)
        }
        canvas.renderAll()
      },
      onChangeRange(date, str) {
        const beijingTime = dayjs.tz(
          dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
          'Asia/Shanghai'
        ) // 替换为北京时间
        const gmtPlus1Time = dayjs.tz(str[0], 'Europe/London') // 替换为GMT+1时间

        const diff = gmtPlus1Time.diff(beijingTime)

        // 获取天、小时、分钟、秒数差异
        // const duration = dayjs.duration(diff)
        const days = dayjs.duration(diff).days()
        const hours = dayjs.duration(diff).hours()
        const minutes = dayjs.duration(diff).minutes()
        const seconds = dayjs.duration(diff).seconds()

        console.log(`差异：${days}天 ${hours}小时 ${minutes}分钟 ${seconds}秒`)

        // 获取选中的 Group 对象
        const activeObject = canvas.getActiveObject()
        if (activeObject instanceof fabric.Group) {
          const objects = activeObject.getObjects()
          objects[9].set('text', `${str[0]}/${str[1]}`)
          objects[9].set('opacity', 0)
          // 重新渲染画布
          canvas.requestRenderAll()
        }
      }
    })

    watch(
      () => state.fontStyle.fill,
      (fill = 'black') => {
        state.changeActiveObject({ fill })
      }
    )

    watch(
      () => state.fontStyle.zIndex,
      (zIndex = 2) => {
        state.changeActiveObject({ zIndex })
      }
    )

    watch(
      () => state.fontStyle.opacity,
      (opacity = 0) => {
        state.changeActiveObject({ opacity })
      }
    )

    watch(
      () => state.fontStyle.fill,
      (fill = 'black') => {
        state.changeActiveObject({ fill })
      }
    )

    onMounted(() => {
      let { fabricSrc } = inject('initState')
      state.init(fabricSrc)
    })
    const init = inject('initState')

    watchEffect(() => {
      if (init.fabricVisible) {
        nextTick(() => {
          console.log('canvas', canvas)
        })
      }
    })

    return {
      ...toRefs(inject('initState')),
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
canvas {
  border: 1px solid #ddd;
}
.media {
  display: flex;
  flex-direction: row;
  justify-content: center;
  background: #fff;
  padding: 10px 0;
}

.media .icon {
  font-size: 20px;
  cursor: pointer;
}

.sortIcon {
  border: 1px solid #ccc;
  height: 30px;
  width: 30px;
  text-align: center;
  line-height: 30px;
}

.attrsContainer {
  width: 300px;
  height: 400px;
  padding: 10px;
  border-radius: 3px;
  border: 1px solid #ddd;
  background: #fff;
  display: block;
}

.font-li {
  width: auto;
  margin-bottom: 10px;
}

.font-li.fontD {
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
}

.font-li.fontD span,
.font-li.fontL span {
  cursor: pointer;
}

.mb0 {
  margin-bottom: 0;
}

.fabricContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.canvasContainer {
  overflow-x: scroll;
}
</style>
<style>
.colorP {
  border: 1px solid #ccc;
  padding: 3px 0 4px 4px;
  width: 126px;
  display: inline-block;
}
</style>
<style>
.vc-lightness-slider,
.vc-display {
  display: none !important;
}
</style>
